export const locale = {
    lang: "en-US",
    data: {
        ADD_CREDIT_CARD: {
            TITLE: "Add New Credit Card",
            ADD_BUTTON: "Save",
            IS_DEFAULT: "Use as Default"
        }
    }
};
